declare const THREE: any;

const getRaycaster = (): any => {
  return new THREE.Raycaster();
};

export default getRaycaster;
